/** Dispatched on `window` to open the full search window (the ⌘K palette) —
 *  from the header's search button on a phone, where there is no room for
 *  an input in the bar. */
export const OPEN_SEARCH_EVENT = "animeshadow:open-search";
export const SEARCH_STATE_EVENT = "animeshadow:search-state";
